// import FlowbiteScript from "../flowbitScript";

const { default: Aside } = require("../Aside");
const { default: Navbar } = require("../Navbar");
const { SidebarProvider } = require("../SidebarContext");

export default function AdminLayout() {

    return (
        <>
            {/* <FlowbiteScript /> */}
            <SidebarProvider>
                <Navbar sticky={true} />
                <Aside />
            </SidebarProvider>
        </>
    );
}